
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import { connect } from 'react-redux';
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getSwarmSubscriptionRequestHorseRacing } from "../../../helpers/terminalRequests/horseRacing";
import { createSelector } from "reselect";
import PropTypes from "prop-types";

let ctx;

class HorseRacing extends Component {
    constructor (props) {
        super(props);
        this.state = {
        };
        //this.selectRegion = this.selectRegion.bind(this);
        this.scroll = this.scroll.bind(this);
    }
    static getDerivedStateFromProps (props, state) {
        return {
            selectedRegionId: props.params.regionId
        };
    }
    /**
     * @name selectRegion
     * @param {string} id
     * @description Select region by id
     * @return {function}
     * */
    // selectRegion (id) {
    //     return () => this.setState({selectedRegionId: id});
    // }

    scroll (scrollSize) {
        return () => {
            let iterator = (scrollSize > 0 ? 0.1 : -0.1);
            this.delta = this.delta || iterator;
            this.delta += iterator;
            this.horseRacing.scrollTop += (scrollSize + this.delta);
        };
    }

    render () {
        ctx = this.props;

        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

HorseRacing.propTypes = {
    data: PropTypes.array,
    loaded: PropTypes.bool
};

const mapStateToProps = (_, ownProps) => {
    const key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestHorseRacing(ownProps.params.sportId));
    return createSelector([
        state => state.swarmData.data[key] && JSON.stringify(state.swarmData.data[key]),
        state => state.swarmData.loaded[key]
    ],
    (data, loaded) => {
        let regionCount, firstRegionId, temp;
        if (data) {
            temp = Object.values(JSON.parse(data || '{}').region).sort((a, b) => a.order - b.order);
            if (temp && temp.length > 0 && loaded) {
                regionCount = temp.length;
                firstRegionId = temp[0].id;
            } else if (temp && temp.length === 0) {
                regionCount = 0;
            }
        }
        return {
            regionCount,
            loaded,
            firstRegionId,
            selectorKey: key,
            data: temp
        };
    });
};

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: HorseRacing,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestHorseRacing(this.props.params.sportId);
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestHorseRacing(this.props.params.sportId));
    },
    ComponentWillReceiveProps: function (nextProps) {
        if (!nextProps.params.regionId && nextProps.firstRegionId) {
            if (ctx && nextProps.location.pathname.indexOf(nextProps.firstRegionId) === -1) {
                console.log(this);
                return ctx.router.replace(nextProps.location.pathname + "/" + nextProps.firstRegionId);
            }
        }
    }
}));